import React from "react";
import logo from "./LogoG.jpg";
import { TextField } from "@mui/material";
import NumbersIcon from "@mui/icons-material/Numbers";

function BolHeader({ date, setDate, onOrderNumberChange, orderNumber }) {
  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 20px",
          borderBottom: "1px solid #ccc",
          textTransform: "uppercase",
        }}
      >
        <TextField
          label="Date"
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          variant="standard"
        />
        <TextField
          required
          label="Order number"
          variant="outlined"
          value={orderNumber}
          onChange={(e) => onOrderNumberChange(e.target.value.toUpperCase())}
          style={{ width: "20%", marginTop: "2%" }}
          InputProps={{
            disableUnderline: true,
            startAdornment: (
              <NumbersIcon style={{ fontSize: 20 }}></NumbersIcon>
            ),
          }}
        />
        <h1>Bill of Lading</h1>
        <img
          src={logo}
          alt="Company Logo"
          style={{ width: "100px", height: "auto" }}
        />
      </div>
    </form>
  );
}

export default BolHeader;
